// src/menu-items/statistics.ts
import { Plus, ShopFourTiles } from 'iconoir-react';


const resellers = {
  id: 'resellers-group',
  title: 'Resellers',
  type: 'group',
  children: [
    {
      id: 'resellers-search',
      title: 'Resellers',
      type: 'item',
      url: '/resellers/search',
      icon: ShopFourTiles,
      breadcrumbs: true
    },
    {
      id: 'resellers-create',
      title: 'Create Reseller',
      type: 'item',
      url: '/resellers/add',
      icon: Plus,
      breadcrumbs: true
    }
  ]
};

export default resellers;
